import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpPendingReportPage } from '@/features/pcmp/pages/PcmpPendingReportPage';
import { pcmpPendingReportSearchSchema } from '@/features/pcmp/types/pcmpReports.types';

export const Route = createFileRoute('/_auth/pcmp/reports/pending/')({
  validateSearch: pcmpPendingReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Pending Report">
      <Suspense fallback={<PageLoader />}>
        <PcmpPendingReportPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
